<template>
  <div class="log">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @on-load="getList"
        @search-change="searchChange"
        :search.sync="search"
        @search-reset="searchRest"
        @refresh-change="refreshChange"
        @row-update="update"
        @row-save="handleSave"
        @selection-change="selectionChange"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
        <template slot="menuLeft" slot-scope="{ size }">
          <el-checkbox v-model="hideFlag" @change="hideChange">
            信用分是否修改过
          </el-checkbox>
          <el-checkbox v-model="prohibitFlag" @change="hideChange">
            是否禁用
          </el-checkbox>
        </template>
        <template slot-scope="{ disabled, size }" slot="nickNameSearch">
          <el-form-item label-width="170px" label="译员昵称/姓名/手机号码">
            <el-input
              placeholder="请输入译员昵称/姓名/手机号码"
              :disabled="disabled"
              :size="size"
              v-model="search.nickName"
            ></el-input>
          </el-form-item>
        </template>
        <template slot="id" slot-scope="scope">
          <el-badge
            :value="
              scope.row.isDisabled === 'y'
                ? scope.row.disabledNum > 2
                  ? '禁'
                  : '禁' + scope.row.disabledNum
                : ''
            "
            class="item"
            type="danger"
          >
            <el-badge
              :value="scope.row.pointAutoUpdate === 'n' ? '改' : ''"
              class="item badge-item"
              type="warning"
            >
              <span>{{ scope.row.id }}</span>
            </el-badge>
          </el-badge>
        </template>
        <template slot-scope="scope" slot="peStatus">
          <avue-switch
            inactive-color="#13ce66"
            active-color="#ff4949"
            v-model="scope.row.peStatus"
            @click="peStatusChange(scope.row)"
            :dic="dic"
          ></avue-switch>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            icon="el-icon-close"
            size="small"
            type="text"
            @click="handleRowClick(scope.row, scope.index)"
          >
            取消备用
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog
      :visible.sync="dialogFormVisible"
      title="操作日志"
      width="80%"
      @close="dialogFormVisible"
    >
      <avue-crud
        :data="logListData"
        :option="option"
        :table-loading="logTableLoading"
        :page.sync="logPage"
        @on-load="logList"
        @size-change="logSizeChange"
        @current-change="logCurrentChange"
      ></avue-crud>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogFormImport"
      title="批量导入"
      width="50%"
      @close="dialogFormImport"
    >
      <span>下载模板，为提高导入的成功率，请下载并使用系统提供的模板</span>
      <el-button
        style="margin-left: 20px"
        type="success"
        size="small"
        @click="downLoadTemplate()"
      >
        下载exlce模板
      </el-button>
      <div style="display: flex">
        <span style="padding-left: 30px; padding-right: 5px; padding-top: 20px">
          <span style="color: red">*</span>
          资源列表导入excel:
        </span>
        <el-upload
          ref="upload"
          class="upload-demo"
          style="padding: 15px"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :on-error="handleError"
          :auto-upload="false"
          drag
          :data="importObj"
          :limit="1"
          :action="uploadurl"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            请上传excle,只支持单sheet 权限列：启用/禁用, 信用分值列：0-100的整数
          </div>
        </el-upload>
      </div>
      <avue-form
        :option="importOption"
        v-model="importObj"
        @submit="importSubmit"
        @error="error"
      ></avue-form>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogFormStatus"
      title="修改译员状态"
      width="50%"
      @close="dialogFormStatus = false"
    >
      <avue-form
        :option="statusOption"
        v-model="statusObj"
        @submit="statusSubmit"
        @error="error"
      ></avue-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  putObj,
  getObj,
  addObj,
  saveOneEdit,
  backupList,
} from '@/api/resource/backup';
import { removeBackUp } from '@/api/resource/list';
import { statistics } from '@/api/dot/flow';
import axios from '@/router/axios';
import { tableOption } from '@/const/crud/resource/backup';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'backup',
  data() {
    return {
      hideFlag: null,
      prohibitFlag: null,
      form: {},
      tempForm: {},
      dialogFormVisible: false, //表格显示隐藏
      dialogFormImport: false, //表格显示隐藏
      dialogFormExport: false, //表格显示隐藏
      dialogFormStatus: false, //表格显示隐藏
      logTableLoading: false,
      statusSubmitFlag: false, //打标权限、打标审核权限、PE权限、PE审核权限是否点击提交标识
      search: {},
      logId: '',
      dic: [
        {
          value: 1,
        },
        {
          value: 2,
        },
      ],
      credibility: '',
      tableData: [],
      logListData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      logPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      tableLoading: false,
      importObj: {},
      exportObj: {},
      statusObj: {},
      idList: [],
      tableOption: tableOption,
      option: {
        addBtn: false,
        refreshBtn: false,
        columnBtn: false,
        header: false,
        menu: false,
        align: 'center',
        menuAlign: 'center',
        column: [
          {
            label: '更新类型',
            prop: 'pointTypeStr',
            minWidth: 80,
          },
          {
            label: '操作前',
            prop: 'oldData',
            minWidth: 80,
          },
          {
            label: '操作后',
            prop: 'newData',
            minWidth: 80,
          },
          {
            label: '更新原因',
            minWidth: 550,
            prop: 'remark',
          },
          {
            label: '更新人',
            minWidth: 80,
            prop: 'updateUser',
          },
          {
            label: '时间',
            minWidth: 120,
            prop: 'createTimeStr',
            // type: "date",
            // format: "yyyy-MM-dd hh:mm:ss",
            // valueFormat: "yyyy-MM-dd hh:mm:ss",
          },
        ],
      },
      importOption: {
        column: [
          {
            label: '更新原因',
            labelWidth: 100,
            row: true,
            type: 'textarea',
            prop: 'remark',
            hide: true,
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入更新原因',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      exportOption: {},
      statusOption: {
        emptyBtn: false,
        column: [
          {
            label: '译员ID',
            disabled: true,
            row: true,
            prop: 'id',
            span: 24,
          },
          {
            label: '类型',
            prop: 'type',
            type: 'select',
            dicData: [
              {
                label: '打标开关',
                value: 3,
              },
              {
                label: '打标审核开关',
                value: 4,
              },
              {
                label: 'PE开关',
                value: 5,
              },
              {
                label: 'PE审核开关',
                value: 6,
              },
            ],
            row: true,
            disabled: true,
            span: 24,
          },
          {
            label: '状态',
            disabled: true,
            row: true,
            type: 'select',
            dicData: [
              {
                label: '开启',
                value: 1,
              },
              {
                label: '关闭',
                value: 2,
              },
            ],
            prop: 'status',
            span: 24,
          },
          {
            label: '备注',
            prop: 'remark',
            row: true,
            type: 'textarea',
            rules: [
              {
                required: true,
                message: '请输入操作备注',
                trigger: 'blur',
              },
            ],
            span: 24,
          },
        ],
      },
      staParams: null,
      uploadurl: '',
    };
  },
  computed: {
    ...mapGetters(['permissions', 'userInfo']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  created() {
    this.resource_batch_import = this.permissions['resource_batch_import'];
    this.resource_edit = this.permissions['resource_edit'];
    this.resource_export = this.permissions['resource_export'];
  },
  mounted() {
    this.uploadurl = this.baseUrl + '/dotadmin/dotPoint/saveBatchEdit';
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '备用资源库',
    };
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    // 排序改变
    sortChange(column) {
      this.orderObj = {
        prop: column.prop,
        order: column.order,
      };
      this.getList(this.page);
    },
    handleRowClick(row, index) {
      // this.$refs.crud.rowEdit(row,index);
      removeBackUp({
        trIds: row.id,
        staffId: this.userInfo.staffCode,
      }).then((res) => {
        if (res.data.data > 0) {
          this.getList(this.page);
          this.$message.success('取消备用资源库成功');
        } else {
          this.$message.error('程序异常，请联系管理员');
        }
      });
      statistics(
        Object.assign(
          {
            event_name: '取消备用',
            event_type: 'click',
            class_name: 'removeBackUp',
            class_url: '/dotadmin/dotRisk/removeBackUp',
            event_params: '{trIds: row.id, staffId: this.userInfo.staffCode}',
          },
          this.staParams,
        ),
      );
    },
    handleSave(row, done) {
      saveOneEdit(
        Object.assign(row, {
          nickName: this.userInfo.username,
        }),
      ).then((res) => {
        if (res.data.data > 0) {
          this.$message.success(res.data.msg);
          this.refreshChange();
          done();
        } else {
          this.$message.error(res.data.msg);
          done();
        }
      });
    },
    hideChange() {
      this.getList(this.page, this.search);
    },
    // 译员清空有问题
    searchRest(form) {
      this.search.id = '';
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUpload(file) {
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let size = file.size / 1024 / 1024;
      if (extension.indexOf('xls') > 0) {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
      }
      // if (size > 10) {
      //   this.$message.warning("文件大小不得超过10M");
      // }
    },
    // 文件上传成功
    handleSuccess(res, file, fileList) {
      if (res.code === 0) {
        this.$message.success('文件上传成功！' + res.data);
        this.getList(this.page);
        this.$refs.upload.clearFiles(); //清空文件
      } else {
        this.$message.error(res.msg);
        this.$refs.upload.clearFiles(); //清空文件
      }
    },
    // 文件上传失败
    handleError(err, file, fileList) {
      this.$message.error('文件上传失败');
      this.$refs.upload.clearFiles(); //清空文件
    },
    downLoadTemplate() {
      window.open(
        'https://woordee.oss-cn-shanghai.aliyuncs.com/%E8%AF%91%E5%91%98%E4%BF%A1%E7%94%A8%E8%AE%B0%E5%BD%95.xlsx',
        '_self',
        '',
      );
    },
    markingStatusChange(data) {
      // console.log(data)
      this.dialogFormStatus = true;
      this.statusObj = {
        id: data.id,
        type: 3,
        status: data.markingStatus,
        remark: '',
      };
    },
    markingAuditStatusChange(data) {
      this.dialogFormStatus = true;
      this.statusObj = {
        id: data.id,
        type: 4,
        status: data.markingAuditStatus,
        remark: '',
      };
    },
    peStatusChange(data) {
      this.dialogFormStatus = true;
      this.statusObj = {
        id: data.id,
        type: 5,
        status: data.peStatus,
        remark: '',
      };
    },
    peAuditStatusChange(data) {
      this.dialogFormStatus = true;
      this.statusObj = {
        id: data.id,
        type: 6,
        status: data.peAuditStatus,
        remark: '',
      };
    },
    btnImport() {
      this.dialogFormImport = true;
    },
    btnExport() {
      // this.dialogFormExport = true;
      axios({
        method: 'post',
        url: '/dotadmin/dotPoint/export',
        data: { remark: this.idList.join() },
        responseType: 'blob', // 重要， 限制返回的数据结构为blob格式，方便前端做转换
      }).then((res) => {
        let a = res.headers['content-disposition'];
        let fileName = decodeURIComponent(a.substr(a.indexOf('=') + 1));
        const link = document.createElement('a');
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    handleItem: function (row) {
      this.logId = row.id;
      this.dialogFormVisible = true;
      this.logList(this.logPage);
    },
    logList(page, params) {
      this.logTableLoading = true;
      getObj(
        Object.assign(
          {
            pageNo: page.currentPage,
            pageSize: page.pageSize,
            id: this.logId,
          },
          params,
        ),
      ).then((res) => {
        if (res.data.data) {
          this.logListData = res.data.data.records;
          this.logPage.total = res.data.data.total;
          this.logTableLoading = false;
        } else {
          this.logListData = [];
          this.logPage.total = 0;
          this.logTableLoading = false;
        }
      });
    },
    importSubmit(form, done) {
      this.importObj.userName = this.userInfo.username;
      this.$refs.upload.submit();
      this.dialogFormImport = false;
      // this.$message.success(JSON.stringify(form));
      done();
    },
    handleBeforeUpload(file) {
      this.$message.success(file);
    },
    statusSubmit(form, done) {
      this.statusSubmitFlag = true;
      this.statusObj.userId = this.userInfo.username;
      addObj(this.statusObj)
        .then(() => {
          // this.getList(this.page);
          this.dialogFormStatus = false;
        })
        .then(() => {
          this.statusSubmitFlag = false;
          this.tableLoading = false;
        });
      done();
    },
    error(err) {
      // this.$message.success('请查看控制台');
    },
    dialogFormVisible() {
      this.dialogFormVisible = false;
    },
    selectionChange(list) {
      // this.$message.success('选中的数据'+ JSON.stringify(list));
      this.idList = list.map((it) => it.id);
    },
    getList(page, params) {
      this.tableLoading = true;
      backupList(
        Object.assign(
          {
            pageNo: page.currentPage,
            pageSize: page.pageSize,
            pointAutoUpdate: this.hideFlag ? 'n' : null,
            isDisabled: this.prohibitFlag ? 'y' : null,
          },
          params,
          this.orderObj,
        ),
      ).then((response) => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
        this.tableLoading = false;
      });
    },
    searchChange(form, done) {
      this.tempForm = form;
      this.page.currentPage = 1; //避免翻页了再搜索为空的情况，明明应该有数据
      this.getList(this.page, form);
      done();
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    currentChange(current) {
      this.page.currentPage = current;
    },
    logSizeChange(pageSize) {
      this.logPage.pageSize = pageSize;
    },
    logCurrentChange(current) {
      this.logPage.currentPage = current;
    },
    refreshChange() {
      this.getList(this.page);
    },
    update(row, index, done, loading) {
      putObj(Object.assign(this.form, { nickName: this.userInfo.username }))
        .then(() => {
          this.getList(this.page, this.tempForm);
          done();
          this.$message.success('修改成功');
        })
        .catch(() => {
          loading();
        });
    },
  },
  watch: {
    // 打标权限、打标审核权限、PE权限、PE审核权限是否点击提交标识 false的时候不刷新
    dialogFormStatus(val) {
      if (!val && !this.statusSubmitFlag) {
        this.getList(this.page);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(label[for='nickName']) {
  display: none;
}
.item {
  margin-top: 10px;
  margin-right: 25px;
}
:deep(.badge-item) {
  position: relative;
  bottom: 9px;
}
</style>
